/* eslint-disable prettier/prettier */
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
  "gitBuildGlobalVersion": "1.24.9",
  "gitBuildTime": "2024-08-14T14:54:16.210Z",
  "gitBuildVersion": "1.24.9",
  "gitCommitId": "10bc9b7",
  "gitCommitIdFull": "10bc9b74e926cdca50135e536d67adb070bef1f6",
  "gitCommitTime": "2024-08-14T14:53:03.000Z",
  "version": "1.24.9-2024-08-14T14:53:03.000Z-(10bc9b7)"
};
